import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react'
import { Row, Col, DatePicker, Button, Input, Select, Form, Tag, Cascader, message, InputNumber } from 'antd'
import PushTimePicker from './PushTimePicker';
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import moment from 'moment'
import './ScreenEventPlaylistModuleEditor.css'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';
import Cleave from 'cleave.js/react';
import PopupManager from '../managers/PopupManager';
import Colors from '../config/Colors';

const { RangePicker } = DatePicker;

const ScreenEventPlaylistModuleEditor = forwardRef((props, ref) => {


    const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
    const weekdayNums = [1, 2, 3, 4, 5, 6, 0]
    const { data = { WeekDay: "0,1,2,3,4,5,6", Priority: 1 }, eventTypes = [], selectedBrandData, selectedBranchData, requestServerGet, userdata } = props;
    const { WeekDay, StartTime, EndTime, StartDate, EndDate } = data;
    // const [schedules, setSchedules] = useState({ WeekDay: [], StartTime: "", EndTime: "", StartDate: "", EndDate: "" })
    const [scData, setScData] = useState(null)
    const [eventsData, setEventsData] = useState([])
    const [screenEventsData, setScreenEventsData] = useState([])
    const [eventsOption, setEventsOption] = useState(null)
    const [days, setDays] = useState([])
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [priority, setPriority] = useState(1)
    const [eventPlaylistID, setEventPlaylistID] = useState(null)
    const [eventPlaylistName, setEventPlaylistName] = useState("")
    const [eventTypeID, setEventTypeID] = useState(null)
    const [initialSelection, setInitialSelection] = useState(undefined)


    const formItemLayout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 12 },
    };


    useEffect(() => {

        reloadFromProps();


    }, [])

    useEffect(() => {

    }, [props])

    useEffect(() => {



        const { selectedBrandData, selectedBranchData, requestServerGet, userdata } = props;


        if (!selectedBrandData) {
            return
        }
        if (!selectedBranchData) {
            return
        }

        requestServerGet("get_eventplaylists", { brandid: selectedBrandData.BrandID, branchid: selectedBranchData.BranchID }, null, (response) => {

            requestServerGet("get_screeneventplaylists", { brandid: selectedBrandData.BrandID, branchid: selectedBranchData.BranchID }, null, (screeneventresponse) => {

                setScreenEventsData(screeneventresponse.data)
                setEventsData(response.data)

            }, userdata.token)

        }, userdata.token)

        return () => {
            console.log('cleaned up');
        };
    }, [props])


    useEffect(() => {
        const tempteventsOption = eventTypes.map((type) => {
            console.log("eventsData " + JSON.stringify(eventsData))
            console.log("type.EventTypeID " + type.EventTypeID)
            const eventsWithThisType = eventsData.filter(ed => (ed.EventTypeID === type.EventTypeID))
            if (eventsWithThisType.length) {
                const childrenEvents = eventsWithThisType.map((ed => ({ value: ed.EventPlaylistID, label: ed.EventPlaylistName })))
                return { value: type.EventTypeID, label: type.EventTypeName, children: childrenEvents }
                // return { value: type.EventTypeID, label: <Tag color={type.EventTypeColor}>{type.EventTypeName}</Tag>, children: childrenEvents }
            }
            else {
                return null
            }
        }).filter(fed3 => (fed3 !== null))

        console.log("tempteventsOption " + JSON.stringify(tempteventsOption))
        setEventsOption(tempteventsOption)
    }, [eventsData])

    //bug : last selected eventplaylist not reset
    const reloadFromProps = () => {
        const { data } = props;
        setScData(data)

        if (!data)
            return

        const { EventPlaylistID, EventPlaylistName, EventTypeID, Priority = 1 } = data;

        if (EventTypeID === undefined && EventPlaylistID === undefined) {
            setInitialSelection(undefined)
        }
        else
            setInitialSelection([EventTypeID, EventPlaylistID])
        setEventPlaylistID(EventPlaylistID)
        setEventTypeID(EventTypeID)
        setEventPlaylistName(EventPlaylistName)
        setPriority(Priority)
    }

    useImperativeHandle(ref, () => ({

        resetUnsavedChanged() {
            reloadFromProps();
        }

    }));


    const save = () => {
        const { onSave = () => { }, data, eventTypes = [], requestServerPost, usertoken, screenData } = props;

        const params = new FormData();

        // console.log("screendata " + JSON.stringify(screenData))
        // return;
        const { ScreenID } = screenData;

        if (!eventPlaylistID) {
            message.error("You must select an event")
            return;
        }

        params.append("screenid", ScreenID)
        params.append("eventplaylistid", eventPlaylistID)
        // params.append("weekday", days.join(","))
        // params.append("starttime", startTime)
        // params.append("endtime", endTime)
        // params.append("startdate", startDate)
        // params.append("enddate", endDate)
        params.append("priority", priority)


        const selectedEventType = eventTypes.find(e => e.EventTypeID === eventTypeID)

        const eventTypeColor = selectedEventType ? selectedEventType.EventTypeColor : Colors.blue;

        if (data && ("ScreenEventPlaylistID" in data)) {
            const { ScreenEventPlaylistID } = data
            params.append("screeneventplaylistid", ScreenEventPlaylistID)
            if (screenEventsData.some(se => ((se.ScreenEventPlaylistID !== ScreenEventPlaylistID) && (se.ScreenID === ScreenID) && (se.EventPlaylistID === eventPlaylistID)))) {
                message.error("You already have this event assigned to this screen")
            }
            else {
                requestServerPost("update_screeneventplaylist", params, { }, (response) => {
                    onSave({ ScreenEventPlaylistID: ScreenEventPlaylistID, ScreenID: ScreenID, EventTypeID: eventTypeID, EventTypeColor: eventTypeColor, EventPlaylistID: eventPlaylistID, EventPlaylistName: eventPlaylistName, Priority: priority })
                    PopupManager.closePopup();
                }, usertoken);
            }
        }
        else {

            if (screenEventsData.some(se => ((se.ScreenID === ScreenID) && (se.EventPlaylistID === eventPlaylistID)))) {
                message.error("You already have this event assigned to this screen")
            }
            else {
                requestServerPost("create_screeneventplaylist", params, { }, (response) => {
                    onSave({ ScreenID: ScreenID, EventTypeID: eventTypeID, EventTypeColor: eventTypeColor, EventPlaylistID: eventPlaylistID, EventPlaylistName: eventPlaylistName, Priority: priority })
                    PopupManager.closePopup();
                }, usertoken);
            }
        }
    }

    const filter = (inputValue, path) => path.some((option) => {
        try {

            var reallabel = ""
            if (typeof option.label === "string") {
                reallabel = option.label;
            }
            else {

                reallabel = option.label.props.children;
            }

            console.log("reallabel " + reallabel)
            return reallabel.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        }
        catch (err) {
            return false;
        }
    });


    if (!eventsData) {
        return null;
    }



    const displayRender = (labels, selectedOptions) => {
        console.log("displayRender labels " + JSON.stringify(labels))
        console.log("displayRender selectedOptions " + JSON.stringify(selectedOptions))
        return labels.map((label, i) => {
            const option = selectedOptions[i];

            if (option) {
                if (i === labels.length - 1) {
                    return (
                        <span key={option.value}>
                            {label}
                        </span>
                    );
                }
                return <span key={option.value}>{label} </span>;
            }
            else {
                return ""
            }
        });
    }

    const onChange = (value, selectedOptions) => {
        console.log(value, selectedOptions);

        if (selectedOptions.length) {

            const selectedEventPlaylistID = selectedOptions[selectedOptions.length - 1].value
            const selectedEventPlaylistName = selectedOptions[selectedOptions.length - 1].label
            const selectedEventTypeID = selectedOptions[0].value
            setEventPlaylistID(selectedEventPlaylistID)
            setEventPlaylistName(selectedEventPlaylistName)
            setEventTypeID(selectedEventTypeID)
        }
        else {
            setEventPlaylistID(undefined);
            setEventPlaylistName(undefined);
            setEventTypeID(undefined);
        }
    };

    return (
        <Row gutter={16} style={{ width: "100%", maxWidth: "450px" }} justify="space-between">
            <Col span={24}>
                <Form
                    name="validate_other"
                    {...formItemLayout}

                >
                    <Form.Item
                        label="Event"
                    >
                        {eventsOption ? (<Cascader
                            defaultValue={initialSelection}
                            options={eventsOption}
                            onChange={onChange}
                            placeholder="Please select"
                            // displayRender={displayRender}
                            showSearch={{
                                filter,
                            }}
                            onSearch={(value) => console.log(value)}
                        />) : null}

                    </Form.Item>
                    <Form.Item
                        label="Priority"
                    >
                        <InputNumber style={{ borderRadius: "5px" }} min={1} defaultValue={1} value={priority} onChange={(value) => {
                            setPriority(value)
                        }} />
                    </Form.Item>
                </Form>

            </Col>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <Button onClick={save} type="primary">SAVE</Button>
                    </Col>

                </Row>
            </Col>
        </Row >
    )
});

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(ScreenEventPlaylistModuleEditor);
